import { Card, CardContent, CardHeader, CardTitle } from '@folio/components';
import { usePolicyOnDashboard } from '@folio/utils/usePolicyOnDashboard';
import { useQuery } from '@tanstack/react-query';
import { brokerageFirmControllerGetBrokerageFirmQueryOptions } from 'korint-sdk';
import { Building2, User } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Group, Stack } from '@folio/components/ui/flex';
import { Text } from '@folio/components/ui/text';

export function AuthorCardModule() {
  const { t } = useTranslation();
  const { policy } = usePolicyOnDashboard();

  const { data: brokerageFirmName } = useQuery({
    ...brokerageFirmControllerGetBrokerageFirmQueryOptions(policy.brokerageFirm!),
    select: data => data.companyInfo.name,
    enabled: !!policy.brokerageFirm,
  });

  if (!policy.author) {
    return null;
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle>{t('authorCard.title')}</CardTitle>
      </CardHeader>
      <CardContent>
        <Stack gap={0} className="space-x-3">
          {brokerageFirmName && (
            <>
              <Group gap={0} className="space-x-2">
                <Building2 className="size-4" />
                <Text inline weight="bold">
                  {brokerageFirmName}
                </Text>
              </Group>
              <div className="w-px h-4 bg-border" />
            </>
          )}
          <Group gap={0} className="space-x-2">
            <User className="size-4 text-muted-foreground" />
            <Text inline size="sm" tone="muted">
              {policy.author?.email ??
                (policy.author?.firstName && policy.author?.lastName
                  ? `${policy.author.firstName} ${policy.author.lastName}`
                  : '—')}
            </Text>
          </Group>
        </Stack>
      </CardContent>
    </Card>
  );
}
